var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.assignComponent(),{tag:"component",class:{
        'uik-nav-link__wrapper': true,
        'active': _vm.active
    },attrs:{"to":_vm.routerLink,"exact":_vm.exact,"replace":_vm.replace}},[_c('span',{staticClass:"uik-nav-link__text"},[(_vm.icon != '')?_c('span',{staticClass:"uik-nav-link__icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2),(_vm.rightEl != '')?_c('span',{staticClass:"uik-nav-link__rightEl"},[_vm._v(" "+_vm._s(_vm.rightEl)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }